import React from 'react'
import PropTypes from 'prop-types'
import { useCallback, useMemo } from 'sb-hooks'
import { snowplow, constants } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Button from 'components/_new/Button/Button'
import Text from 'components/_new/typography/Text/Text'

import getSuggestion from './util/getSuggestion'

import messages from './messages'
import s from './EmailSuggestion.scss'


const EmailSuggestion = ({ email, onConfirm }) => {
  const suggestion = useMemo(() => getSuggestion(email), [ email ])
  const domainName = suggestion.replace(/.*@/, '')

  const handleConfirm = useCallback(() => {
    snowplow.track(constants.snowplowEvents.emailFixed)
    onConfirm(suggestion)
  }, [ suggestion, onConfirm ])

  return Boolean(suggestion) && (
    <div
      className={s.emailSuggestion}
      role="region"
      aria-live="polite"
      data-testid={constants.testIds.register.emailSuggestion}
    >
      <Box pt="12" pb="12">
        <Text message={{ ...messages.text, values: { domainName } }} html />
      </Box>
      <Button
        className={s.button}
        size="sm"
        onClick={handleConfirm}
        title={messages.button}
        weight="normal"
        uppercase
      />
    </div>
  )
}

EmailSuggestion.propTypes = {
  email: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
}


export default EmailSuggestion
